import React from 'react'
import classNames from 'classnames/bind'

import styles from './CatalogListHeader.module.css'

const cx = classNames.bind(styles)

interface CatalogListHeaderProps {
  departmentName?: string
  departmentImage?: string
  isSubDepartment?: boolean
}

const CatalogListHeader = ({ departmentName, departmentImage, isSubDepartment = false }: CatalogListHeaderProps) => {
  return (
    <div className={styles.headerContainer}>
      {departmentImage && <img className={styles.departmentImage} src={departmentImage} alt="" />}
      <div className={styles.contentContainer}>
        <h1 className={cx(styles.heading, departmentName ? styles.capitalize : '')}>
          Wholesale {departmentName ? departmentName : 'catalogs'}
        </h1>
        {isSubDepartment ? (
          <p className={styles.description}>
            Shop wholesale {departmentName ? departmentName : ''} catalogs and suppliers.
          </p>
        ) : (
          <p className={styles.description}>
            Shop thousands of wholesale {departmentName ? departmentName : ''}
            {departmentName ? <br /> : ''}products, catalogs and suppliers.
          </p>
        )}
      </div>
    </div>
  )
}

export default CatalogListHeader
